

























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { contentService, termsOfUseService } from "../services";
import { TermsOfUseStatus } from "../models";

@Component
export default class TermsView extends Vue {
    termsBody: null | string = null;
    status: null | TermsOfUseStatus = null;

    accepting = false;

    async mounted() {
        const result = await Promise.all([
            contentService.getContentString("mobisulo.termsofuse.body"),
            termsOfUseService.getTermsOfUseStatus("Mobisulo")
        ]);

        this.termsBody = result[0];
        this.status = result[1];
    }

    async accept() {
        this.accepting = true;
        await termsOfUseService.acceptTermsOfUse("Mobisulo");
        this.$emit("accepted");
    }
}
